<div class="h-100 d-flex flex-column">
  <div *ngIf="!mobileView" class="container-fluid">
    <div class="row py-4 px-2 navy-background">
      <div class="col-xl-6 col-lg-6 col-md-12 d-flex align-items-center py-1">
        <h5 class="white-font text-uppercase m-0 mr-2">Patients</h5>
      </div>
    </div>
  </div>

  <ngx-loading [show]="loading"></ngx-loading>
  <app-error *ngIf="errorMessage" [message]="errorMessage"></app-error>

  <div class="content flex-grow-1 minh-0">
    <kendo-grid
      [data]="gridView"
      [pageSize]="gridState.take"
      [skip]="gridState.skip"
      [sort]="gridState.sort"
      [sortable]="true"
      [pageable]="true"
      kendoGridSelectBy="patientId"
      [style.height.%]="100"
      [filter]="gridState.filter"
      [filterable]="false"
      (dataStateChange)="dataStateChange($event)"
      (add)="onAddClick($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <div class="d-flex" [ngClass]="{ 'flex-grow-1': mobileView }">
          <span class="d-flex search-box border border-radius" [ngClass]="mobileView ? 'w-100 px-3' : 'pl-4'">
            <div class="align-content-center">
              <i class="fa fa-search"></i>
            </div>
            <mat-form-field [ngClass]="mobileView ? 'pl-3 flex-grow-1' : 'p-3 w-75'">
              <input
                matInput
                placeholder="Search patients..."
                aria-label="Search Patients"
                [(ngModel)]="searchValue"
                (ngModelChange)="search($event)"
              />
              <button
                mat-button
                *ngIf="searchValue"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="search('')"
                style="vertical-align: bottom"
                class="btn-clean"
              >
                <i class="fas fa-times-circle"></i>
              </button>
            </mat-form-field>
          </span>
        </div>
        <ng-container *ngIf="!mobileView">
          <button kendoGridAddCommand type="button" class="btn em-btn">
            <i class="fal fa-plus-circle"></i> Add Patient
          </button>
          <button kendoButton type="button" class="btn em-btn" (click)="mergePatients()">
            <i class="fal fa-user-friends"></i> Merge Patients
          </button>
          <button kendoGridExcelCommand class="btn em-btn m-0" type="button">
            <i class="fal fa-file-excel"></i> Export to Excel
          </button>
        </ng-container>
      </ng-template>
      <kendo-grid-command-column title="" [width]="52">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <button
            class="btn kendo-btn px-0"
            (click)="openPatientPanel(dataItem)"
            kendoTooltip
            tooltipClass="em-tooltip"
            position="top"
            title="Open Patient Panel"
          >
            <i class="fas fa-user px-2"></i>
          </button>
        </ng-template>
      </kendo-grid-command-column>
      <kendo-grid-column title="First Name" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <a (click)="openPatientPanel(dataItem)">{{ dataItem.firstName | titlecase }}</a>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Last Name" [width]="120">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <a (click)="openPatientPanel(dataItem)">{{ dataItem.lastName | titlecase }}</a>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="gender" title="Gender" [width]="90"> </kendo-grid-column>
      <kendo-grid-column field="mobileNumber" title="Mobile Phone" [width]="130" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.mobileNumber | phoneNumber }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="email" title="Email Address" [width]="145" [sortable]="false"></kendo-grid-column>
      <kendo-grid-column
        field="isPreferred"
        title="VIP"
        [width]="58"
        filter="boolean"
        [sortable]="false"
        [headerStyle]="{ justifyContent: 'center' }"
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="text-center">
            <i *ngIf="dataItem.isPreferred" class="fas fa-check"></i>
            <i *ngIf="!dataItem.isPreferred" class="fas fa-times"></i>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="address.city" title="City" [width]="120"></kendo-grid-column>
      <kendo-grid-column field="address.province" title="Province" [width]="120" [sortable]="false">
      </kendo-grid-column>
      <kendo-grid-column field="birthDate" title="Birth Date" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.birthDate | date : 'yyyy-MM-dd' }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="patientStatus" title="Status" [width]="75" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ PatientStatus[dataItem.patientStatus] }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-excel fileName="Patients.xlsx" [fetchData]="allData"></kendo-grid-excel>
      <kendo-grid-pdf fileName="Patients.pdf" [allPages]="true">
        <kendo-grid-pdf-margin top="1cm" left="1cm" right="1cm" bottom="1cm"></kendo-grid-pdf-margin>
      </kendo-grid-pdf>
    </kendo-grid>
  </div>

  <p-overlayPanel #hoverPanel id="hoverPanel" [dismissable]="false"> Content </p-overlayPanel>
  <app-actionpanel></app-actionpanel>
</div>
